export const DISPLAY_FONT_FAMILY = 'HologramDisplay';
export const DISPLAY_FONT_FALLBACK = 'Inter, system-ui, sans-serif';
export const DISPLAY_FONT_APPLIED_EVENT = 'display-font-applied';
/** @deprecated Use DISPLAY_FONT_APPLIED_EVENT */
export const OVERLAY_FONT_APPLIED_EVENT = DISPLAY_FONT_APPLIED_EVENT;
export const DEFAULT_DISPLAY_FONT_LABEL = 'Default (Inter)';

const STYLE_ID = 'display-font-face';

/** @type {{ dataUrl: string | null; fileLabel: string }} */
let displayFontState = {
  dataUrl: null,
  fileLabel: DEFAULT_DISPLAY_FONT_LABEL,
};

/**
 * @param {string} fileName
 * @returns {string | null}
 */
function inferFontFormat(fileName) {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if (ext === 'woff2') return 'woff2';
  if (ext === 'woff') return 'woff';
  if (ext === 'ttf') return 'truetype';
  if (ext === 'otf') return 'opentype';
  return null;
}

function dispatchDisplayFontApplied() {
  window.dispatchEvent(new CustomEvent(DISPLAY_FONT_APPLIED_EVENT));
}

function setDisplayFontCssVariables(active) {
  const stack = active
    ? `'${DISPLAY_FONT_FAMILY}', ${DISPLAY_FONT_FALLBACK}`
    : '';
  if (stack) {
    document.documentElement.style.setProperty('--hologram-display-font', stack);
    document.documentElement.classList.add('display-font-custom');
  } else {
    document.documentElement.style.removeProperty('--hologram-display-font');
    document.documentElement.classList.remove('display-font-custom');
  }
}

/**
 * @param {string} dataUrl
 * @param {string} fileName
 */
export async function applyDisplayFont(dataUrl, fileName) {
  const format = inferFontFormat(fileName);
  if (!format) {
    throw new Error('Unsupported font format. Use woff, woff2, ttf, or otf.');
  }

  let styleEl = document.getElementById(STYLE_ID);
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    document.head.appendChild(styleEl);
  }

  styleEl.textContent = `
    @font-face {
      font-family: '${DISPLAY_FONT_FAMILY}';
      src: url('${dataUrl}') format('${format}');
      font-display: swap;
    }
  `;

  displayFontState = {
    dataUrl,
    fileLabel: fileName,
  };

  setDisplayFontCssVariables(true);

  try {
    await document.fonts.load(`32px '${DISPLAY_FONT_FAMILY}'`);
    await document.fonts.load(`64px '${DISPLAY_FONT_FAMILY}'`);
  } catch {
    /* font may still render once decoded */
  }

  dispatchDisplayFontApplied();
}

export function resetDisplayFont() {
  document.getElementById(STYLE_ID)?.remove();
  displayFontState = {
    dataUrl: null,
    fileLabel: DEFAULT_DISPLAY_FONT_LABEL,
  };
  setDisplayFontCssVariables(false);
  dispatchDisplayFontApplied();
}

/** @returns {{ dataUrl: string | null; fileLabel: string }} */
export function getDisplayFontState() {
  return { ...displayFontState };
}

/**
 * @param {string} dataUrl
 * @param {string} [fileLabel]
 */
export async function applyDisplayFontFromDataUrl(dataUrl, fileLabel = 'Saved font') {
  await applyDisplayFont(dataUrl, fileLabel);
}
